import React from "react";

export const CardContent = ({ children }) => {
  return <div className="text-red-700">{children}</div>;
};


